<template>
    <div class="page-with-top-bar">
        <section>
            <div class="mt-4" v-if="this.company">
                <b-tabs type="is-boxed" v-model="mainActiveTab">
                    <b-tab-item>
                        <template slot="header">
                            <b-icon pack="fas" icon="file-signature"></b-icon>
                            <span> {{ $t('permitting') }} </span>
                        </template>
                        <div>
                            <permitting-template-add ref="add" />
                        </div>
                    </b-tab-item>
                </b-tabs>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import  PermittingTemplateAdd from '·/pages/admin/permitting-templates/permitting-template-add'

    export default {
    middleware: "auth",
    title: "permitting",
    subtitle: '',
    menuOption: "0-8",
    components: {
        PermittingTemplateAdd
    },
    data: () => ({
        mainActiveTab: 0,
    }),
    computed: {
        ...mapGetters({
            company: 'app/company',
        }),
    },
    mounted() {
        if (!this.company) {
            this.$notify.info('Debe seleccionar una empresa')
            this.$router.push({ name: "company.select" });
        }
    },
    }
</script>

<style lang="scss" scoped>

</style>